import CompanyMeetingListView from "@/views/company/meetings/CompanyMeetingListView";

export default [
  {
    name: "pages.company.meetings",
    path: "meetings",
    component: CompanyMeetingListView
  },
  
  
];
